import React from "react";
import { css } from "glamor";
import { spacing } from "../library/theme";
import Question from "../questions/Question";
import LessonQuestionPaginationContainer from "./LessonQuestionPaginationContainer";

const questionWrapperClass = css({
  marginTop: spacing.s,
})

export default function LessonQuestionCarousel(props) {
  const {
    questionRef,
    flattenedLessonQuestions,
    currentQuestionIndex,
    lesson,
  } = props;

  const currentQuestionItem = flattenedLessonQuestions?.[currentQuestionIndex];
  const currentQuestion = currentQuestionItem?.question;
  const currentStem = currentQuestionItem?.stem;

  if (!currentQuestion) {
    return null;
  }

  return (
    <div>
      <LessonQuestionPaginationContainer />

      <div ref={questionRef} data-question-ref className={questionWrapperClass}>
        <Question
          {...props}
          question={currentQuestion}
          lesson={lesson}
          currentStemPosition={currentStem?.position}
        />
      </div>
    </div>
  );
}

